var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"perfil-view"}},[_c('h1',[_vm._v("Perfil")]),_vm._v(" "+_vm._s(_vm.displayUserInfo)+" "+_vm._s(_vm.userInfo)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }